import { DatePipe } from '@angular/common';
import * as moment from 'moment';

export class DateRange {
  public startDate: Date;
  public endDate: Date;
  private datePipe: DatePipe = new DatePipe(moment.locale());

  constructor(_startDate: Date, _endDate: Date) {
    this.startDate = _startDate;
    this.endDate = _endDate;
  }

  hasAnyDates() {
    return this.startDate || this.endDate;
  }

  toString(format, timezone): string {
    if (!this.startDate && !this.endDate) {
      return '';
    }

    if (this.startDate && !this.endDate) {
      return `Start: ${this.datePipe.transform(this.startDate, format, timezone)}`;
    }

    if (!this.startDate && this.endDate) {
      return `End: ${this.datePipe.transform(this.endDate, format, timezone)}`;
    }

    return (
      (this.startDate ? this.datePipe.transform(this.startDate, format, timezone) : '') +
      this.getSeparator() +
      this.datePipe.transform(this.endDate, format, timezone)
    );
  }

  todayIsWithinDateRange() {
    return this.dateIsWithinRange(new Date());
  }

  private dateIsWithinRange(date: Date): boolean {
    var startTime = this.startDate
      ? new Date(this.datePipe.transform(this.startDate)).getTime()
      : undefined;
    var endTime = this.endDate
      ? new Date(this.datePipe.transform(this.endDate)).getTime()
      : undefined;
    var currentTime = date.getTime();

    if (
      (!startTime && !endTime) ||
      (startTime < currentTime && !endTime) ||
      (startTime < currentTime && currentTime < endTime)
    ) {
      return true;
    }

    if (!startTime && endTime && currentTime < endTime) {
      return true;
    }

    return false;
  }

  private getSeparator() {
    return this.startDate && this.endDate ? ' - ' : '';
  }
}
